import React from 'react'
import { Route, Routes } from "react-router-dom";
import UsersPage from '../../pages/features/users/UsersPage';




export default function UserNav() {
  return (
    <Routes>
      <Route path="/" element={<UsersPage />} />
   
    </Routes>
  );
}
